import { render, staticRenderFns } from "./SmartClassifierSetFallback.vue?vue&type=template&id=ca3401e0&scoped=true&"
import script from "./SmartClassifierSetFallback.vue?vue&type=script&lang=js&"
export * from "./SmartClassifierSetFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3401e0",
  null
  
)

export default component.exports